export type FileIconType =
  | "image"
  | "video"
  | "audio"
  | "pdf"
  | "code"
  | "archive"
  | "document"
  | "spreadsheet"
  | "presentation"
  | "folder"
  | "generic";

export function getMimeIcon(mimeType: string, extension?: string): FileIconType {
  if (mimeType.startsWith("image/")) return "image";
  if (mimeType.startsWith("video/")) return "video";
  if (mimeType.startsWith("audio/")) return "audio";
  if (mimeType === "application/pdf") return "pdf";

  if (
    mimeType.startsWith("text/") ||
    [
      "application/json",
      "application/xml",
      "application/javascript",
      "application/typescript",
    ].includes(mimeType)
  ) {
    return "code";
  }

  if (
    mimeType === "application/zip" ||
    mimeType === "application/x-tar" ||
    mimeType === "application/x-gzip" ||
    mimeType === "application/x-7z-compressed" ||
    extension?.match(/^(zip|tar|gz|bz2|7z|rar)$/)
  ) {
    return "archive";
  }

  if (
    mimeType.includes("word") ||
    mimeType.includes("document") ||
    extension?.match(/^(doc|docx|odt|rtf)$/)
  ) {
    return "document";
  }

  if (
    mimeType.includes("spreadsheet") ||
    mimeType.includes("excel") ||
    extension?.match(/^(xls|xlsx|ods|csv)$/)
  ) {
    return "spreadsheet";
  }

  if (
    mimeType.includes("presentation") ||
    mimeType.includes("powerpoint") ||
    extension?.match(/^(ppt|pptx|odp)$/)
  ) {
    return "presentation";
  }

  return "generic";
}
